
export const BASE_URL = 'https://fuel-back.azurewebsites.net';
